import { HTTP } from "@/api";

export default {
  getSocials({ commit }) {
    HTTP.get("/social?active")
      .then(res => {
        const data = res.data;
        if (data.success) commit("social", data.result);
      })
      .catch(console.error);
  }
};
